module.exports = __webpack_public_path__ + "static/media/menu-no-dnd-down.881be683.svg";